module.exports = __webpack_public_path__ + "static/media/DonateCarousel_2-desktop.26a25061.jpg";